export class MpaPoliciesInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<MpaPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MpaPoliciesInfo.attributeTypeMap;
    }
    constructor() {
    }
}
